import type { CSSProperties, ReactElement, ReactNode } from "react"

const COLUMN_MAX_WIDTH_DESKTOP_PX = 418
const COLUMN_FIXED_WIDTH_MOBILE_PX = 264

type ProductBoxesGridProps = {
  numberOfColumns: number
  children: ReactNode
}

export default function ProductBoxesGrid({
  numberOfColumns,
  children,
}: ProductBoxesGridProps): ReactElement {
  const wrapperStyle = {
    "--col-gap": "var(--space-3)",
    "--grid-cols-mobile": `repeat(${numberOfColumns}, ${COLUMN_FIXED_WIDTH_MOBILE_PX}px)`,
    "--grid-cols-desktop": `repeat(${numberOfColumns}, 1fr)`,
    maxWidth: `calc(${numberOfColumns} * ${COLUMN_MAX_WIDTH_DESKTOP_PX}px + ${numberOfColumns - 1} * var(--col-gap))`,
  } as CSSProperties

  return (
    <div
      className="flex justify-center mx-auto overflow-x-auto lg:overflow-x-visible pb-4 lg:pb-0"
      style={wrapperStyle}
    >
      <div className="grid [column-gap:var(--col-gap)] [grid-template-columns:var(--grid-cols-mobile)] lg:[grid-template-columns:var(--grid-cols-desktop)]">
        {children}
      </div>
    </div>
  )
}
